/**
 * Values that define where the toolbar is positioned.
 */
export type ViewerToolbarPlacement =
  | 'top-left'
  | 'top-center'
  | 'top-right'
  | 'middle-left'
  | 'middle-right'
  | 'bottom-left'
  | 'bottom-center'
  | 'bottom-right';

export type ViewerToolbarDirection = 'horizontal' | 'vertical';
